import React from 'react';
import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { addCommas } from 'core/utils/helpers/numbers';
import { bonusButton as orgConfig } from 'org/configs/modules.config';

const defaultConfig = {
  defaults: {
    isPageEligibleToShowModalOrPopup: true,
    bannerConfig: {
      dateFormat: 'M/DD/YY',
      getBonusText: () => 'bonus',
      getTermsText: () => '',
    },
    popupConfig: {
      dateFormat: 'M/DD/YY',
      getConfirmationText: () => 'You got the button',
      getBonusText: () => 'bonus',
      getTermsText: () => 'Terms Apply',
    },
    modalConfig: {
      dateFormat: 'MMMM D, YYYY',
      getTermsText: () => 'Terms Apply',
      getTitle: (maxRewardAvailable, brandCurrency) => (
        <>Get the button and earn {addCommas(maxRewardAvailable)} bonus {brandCurrency}</>
      ),
      getDescription: (brandCurrency, minSpendToQualify, endDateFormated, maxRewardAvailable) => (
        <>Install the button to activate {brandCurrency} and find coupons while you shop. Spend just{' '}
          {minSpendToQualify} by {endDateFormated} to earn {addCommas(maxRewardAvailable)} bonus {brandCurrency}.
        </>
      ),
    },
    slideMessageConfig: {
      dateFormat: 'MMMM D, YYYY',
      getPreTitle: () => 'Limited-time offer:',
      getTitle: (minSpendToQualify, endDateFormated, maxRewardAvailable, brandCurrency) => (
        <>Get the button and spend {addCommas(minSpendToQualify)}{' '}
          through {endDateFormated} to earn {addCommas(maxRewardAvailable)} bonus {brandCurrency}.
        </>
      ),
      getTermsText: () => '',
    },
  },
  foryou: {
    isPageEligibleToShowModalOrPopup: false,
  },
  faq: {
    isPageEligibleToShowModalOrPopup: false,
  },
  contact: {
    isPageEligibleToShowModalOrPopup: false,
  },
  terms: {
    isPageEligibleToShowModalOrPopup: false,
  },
  tc: {
    isPageEligibleToShowModalOrPopup: false,
  },
  privacy: {
    isPageEligibleToShowModalOrPopup: false,
  },
  ai: {
    isPageEligibleToShowModalOrPopup: false,
  },
  eu: {
    isPageEligibleToShowModalOrPopup: false,
  },
  click: {
    isPageEligibleToShowModalOrPopup: false,
  },
  e: {
    isPageEligibleToShowModalOrPopup: false,
  },
  // additionally all sorts of button pages are excluded at `useCheckIsEligibleToFetchData` hook level
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
